<template>
  <div class="footer">
    <div class="tex tex1">主办单位名称：江阴千游网络科技有限公司</div>
    <div class="tex">App备案号：苏ICP备2022030317号-8</div>
    <div class="tex">违规投诉/举报邮箱：xiecheng1@3975.com</div>
    <div class="tex">违规投诉/举报邮箱：jiankongzu2024@163.com</div>
    <div class="tex footer-warning-text">
      健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 防受骗上当
      适度游戏益脑 迷游戏伤身 合理安排时间 享受健康生活
      <div>
        <router-link to="/yinsi" target="_blank">《隐私政策》</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadGameFooterMobile',
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  height: 5.5rem;
  background: #231c0e;
  color: #ffffff;
  font-size: 0.32rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.533333rem;
}

.footer--match-theme {
  background: #000000;
}

.tex1 {
  margin-top: 0.5rem;
}

.footer-warning-text {
  width: 7.3rem;
  height: 1.38rem;
  text-align: center;
  margin-top: 0.13rem;
  margin-bottom: 1.06rem;
}

a {
  color: #ffffff;
}
</style>
